module.exports = __webpack_public_path__ + "static/posicionamiento2-eafa036d281fbcfc3b9cfec658543842.jpg";